import type { ProductSelectionData } from '../components/image-generation/ProductSelectionModal';

const PERSON_LABELS: Record<string, string> = {
  include_person: '人物を含める',
  person_using: '商品を使用している人物を含める',
  person_happy: '満足している人物を含める',
  no_person: '人物を含めない',
};
/**
 * バナーの商品選択結果を、構造化商品データを直接受け取らない生成API向けの
 * 共通テキストへ変換する。
 */
export const buildProductGenerationPrompt = (
  data: ProductSelectionData,
  additionalInstructions = ''
): string => {
  const { product } = data;
  const productMetadata = product.extended_metadata?.product;
  const pricing = product.extended_metadata?.pricing_offer;
  const lines = [`商品名: ${product.name}`];

  if (productMetadata?.brand) lines.push(`ブランド: ${productMetadata.brand}`);
  if (product.description || productMetadata?.description) {
    lines.push(`商品説明: ${product.description || productMetadata?.description}`);
  }
  if (productMetadata?.usp) lines.push(`USP: ${productMetadata.usp}`);
  if (productMetadata?.use_scenarios) lines.push(`利用シーン: ${productMetadata.use_scenarios}`);
  if (data.segmentName) lines.push(`ターゲット: ${data.segmentName}`);
  if (data.appealName) {
    lines.push(`訴求軸: ${data.appealName}${data.appealDirection ? ` - ${data.appealDirection}` : ''}`);
  }
  if (data.includePerson && PERSON_LABELS[data.includePerson]) {
    lines.push(`人物の扱い: ${PERSON_LABELS[data.includePerson]}`);
  }
  if (pricing?.price_details) lines.push(`価格: ${pricing.price_details}`);
  if (pricing?.offers_campaigns) lines.push(`オファー: ${pricing.offers_campaigns}`);
  if (pricing?.main_cta) lines.push(`CTA: ${pricing.main_cta}`);

  const details = [data.additionalContext, additionalInstructions.trim()].filter(Boolean).join('\n');
  if (details) lines.push(`詳細指示: ${details}`);

  return lines.join('\n');
};
